import React from 'react';
import Icon from '../../../components/AppIcon';

const BookingSummaryCard = ({ bookingData }) => {
  const formatDate = (date) => {
    return new Date(date)?.toLocaleDateString('en-US', {
      weekday: 'long',
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    });
  };

  const formatTime = (date) => {
    return new Date(date)?.toLocaleTimeString('en-US', {
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  return (
    <div className="bg-card rounded-lg shadow-elevation-3 p-6">
      <div className="flex items-center space-x-3 mb-6">
        <div className="w-10 h-10 rounded-full bg-primary/10 flex items-center justify-center">
          <Icon name="Calendar" size={20} color="var(--color-primary)" strokeWidth={2} />
        </div>
        <h2 className="font-heading text-2xl font-semibold text-foreground">
          Booking Summary
        </h2>
      </div>

      <div className="space-y-4">
        <div className="flex items-center justify-between pb-4 border-b border-border">
          <div className="flex items-center space-x-2">
            <Icon name="CheckCircle2" size={18} color="var(--color-success)" strokeWidth={2} />
            <span className="font-body text-sm text-muted-foreground">Status</span>
          </div>
          <span className="px-3 py-1 bg-success/10 text-success text-sm font-medium rounded-full">
            Confirmed
          </span>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div className="space-y-1">
            <div className="flex items-center space-x-2 text-muted-foreground">
              <Icon name="CalendarCheck" size={16} strokeWidth={2} />
              <span className="font-caption text-xs uppercase">Pick-up Date</span>
            </div>
            <p className="font-body text-base font-medium text-foreground ml-6">
              {formatDate(bookingData?.startDate)}
            </p>
          </div>

          <div className="space-y-1">
            <div className="flex items-center space-x-2 text-muted-foreground">
              <Icon name="CalendarCheck" size={16} strokeWidth={2} />
              <span className="font-caption text-xs uppercase">Return Date</span>
            </div>
            <p className="font-body text-base font-medium text-foreground ml-6">
              {formatDate(bookingData?.endDate)}
            </p>
          </div>
        </div>

        <div className="pt-4 border-t border-border">
          <div className="flex items-center justify-between">
            <div className="flex items-center space-x-2">
              <Icon name="Clock" size={18} color="var(--color-primary)" strokeWidth={2} />
              <span className="font-body text-base text-muted-foreground">Total Duration</span>
            </div>
            <span className="font-heading text-lg font-semibold text-primary">
              {bookingData?.pricing?.days} {bookingData?.pricing?.days === 1 ? 'Day' : 'Days'}
            </span>
          </div>
        </div>

        <div className="pt-4 border-t border-border">
          <div className="flex items-start space-x-3 p-3 bg-primary/5 rounded-md">
            <Icon name="Mail" size={18} color="var(--color-primary)" strokeWidth={2} />
            <div>
              <p className="font-body text-sm font-medium text-foreground mb-1">
                Confirmation Email Sent
              </p>
              <p className="font-body text-xs text-muted-foreground">
                Check your inbox for detailed booking information and rental agreement at {formatTime(bookingData?.createdAt)}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BookingSummaryCard;